import React from "react";
import "./Header.scss";

const Header = (props) => {
    return (
        <header className="header">
            <nav className="navbar">
                <a href="#home" className="logo">
                    <img
                        src="./images/forhad_icon.png"
                        alt="icon"
                        className="bgImg"
                    />
                </a>
                <div className="menuItems">
                    <a href="#home">
                        <div className="menuItem">Home</div>
                    </a>
                    <a href="#about">
                        <div className="menuItem">About</div>
                    </a>
                    <a href="#skills">
                        <div className="menuItem">Skills</div>
                    </a>
                    <a href="#projects">
                        <div className="menuItem">Projects</div>
                    </a>
                    <a href="#guru">
                        <div className="menuItem">Guru</div>
                    </a>
                    <a href="#contact">
                        <div className="menuItem">Contact</div>
                    </a>
                </div>
                <div className="nav-btn" onClick={props.sidebarHandler}>
                    &#9776;
                </div>
            </nav>
        </header>
    );
};

export default Header;
